import React from 'react';
import RescueContainer from '../RescueContainer';

export default function PurchaseGiftCards() {
  return <RescueContainer />;
}
